import Quill from "quill";

import { sanitizeHtmlInput } from "@utilities/sanitizeHtmlInput";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Clipboard = Quill.import("modules/clipboard") as any;

/**
 * Copied from Quill because I couldn't import.
 */
export interface IRangeStatic {
  index: number;
  length: number;
}

/**
 * CustomClipboard is a class that extends the Quill Clipboard module.
 * It overrides the onPaste method to sanitize pasted HTML content.
 */
class CustomClipboard extends Clipboard {
  // noinspection JSUnusedGlobalSymbols
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData?.getData("text/html") || clipboardData?.getData("text/plain");
    if (!pastedData) return;
    // Sanitize the pasted data
    const sanitizedData = sanitizeHtmlInput(pastedData);

    const range: IRangeStatic = this.quill.getSelection(true) as IRangeStatic;
    // delete the selected range, if it exists
    if (range) {
      this.quill.deleteText(range.index, range.length);
      // insert the sanitized pasted data

      this.quill?.clipboard.dangerouslyPasteHTML(range.index, sanitizedData);
    }
  }
}

Quill.register("modules/clipboard", CustomClipboard);
